import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "../css/header.css";
import salaryUncleLogo from "../images/salary_uncle_logo.png";

const IcoPhone = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.6 3.41 2 2 0 0 1 3.58 1.23h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.78a16 16 0 0 0 6.29 6.29l1.06-.91a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/>
  </svg>
);

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isSticky, setIsSticky] = useState(false);
  const location = useLocation();

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const closeMenu = () => setMenuOpen(false);

  useEffect(() => {
    const handleScroll = () => setIsSticky(window.scrollY > 0);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const isActive = (path) => location.pathname === path ? "active" : "";

  return (
    <>
      {/* TOP BAR */}
      <div className="top-bar">
        <div className="top-bar-left">
          <IcoPhone />
          {/* <a href="tel:+918796041166">+91 87960 41166</a> */}
          {/* <a href="tel:+918130109457">+91 8130109457</a> */}
          {/* <a href="tel:+917428966221">+91 7428966221</a> */}
          <a href="tel:+917042561004">+91 7042561004</a>
        </div>
        <div className="top-bar-right">
          Quick Loans &nbsp;|&nbsp; Trusted by 50,000+ Salaried Professionals
        </div>
      </div>

      {/* MAIN HEADER */}
      <header className={`header-laravel ${isSticky ? "sticky" : ""}`}>

        {/* Hamburger -- mobile only */}
        <div className={`menu-toggle-laravel`} onClick={toggleMenu}>
          <div className="menu-icon-laravel">
            <span className="icon-bar-laravel"></span>
            <span className="icon-bar-laravel"></span>
            <span className="icon-bar-laravel"></span>
          </div>
        </div>

        {/* LOGO -- left */}
        <Link to="/" className="logo" onClick={closeMenu}>
          <img src={salaryUncleLogo} alt="Salary Uncle" className="header-logo-img" />
        </Link>

        {/* NAV -- centre */}
        <nav className={`nav-laravel ${menuOpen ? "open" : ""}`}>
          <span className="close-icon-laravel" onClick={closeMenu}>&#10005;</span>
          <div className="nav-drawer-logo">
            <img src={salaryUncleLogo} alt="Salary Uncle" />
          </div>
          <ul>
            <li><Link to="/" className={isActive("/")} onClick={closeMenu}>Home</Link></li>
            <li><Link to="/about-us" className={isActive("/about-us")} onClick={closeMenu}>About</Link></li>
            <li><Link to="/services" className={isActive("/services")} onClick={closeMenu}>Services</Link></li>
            <li><Link to="/calculator" className={isActive("/calculator")} onClick={closeMenu}>Calculator</Link></li>
            <li><Link to="/blog" className={isActive("/blog")} onClick={closeMenu}>Blog</Link></li>
            <li><Link to="/contact" className={isActive("/contact")} onClick={closeMenu}>Contact</Link></li>
          </ul>

          {/* Drawer bottom CTA buttons -- mobile only */}
          <div className="nav-drawer-cta">
            <Link to="/apply-now" className="nav-drawer-btn nav-drawer-btn-primary" onClick={closeMenu}>Apply Now</Link>
            <Link to="/repay-loan" className="nav-drawer-btn nav-drawer-btn-outline" onClick={closeMenu}>Pay Now</Link>
          </div>
        </nav>

        {/* APPLY NOW + PAY NOW -- right */}
        <div className="header-cta-group">
          <Link to="/apply-now" className="header-apply-link" onClick={closeMenu}>
            <button className="btn-apply-now">Apply Now</button>
          </Link>
          <Link to="/repay-loan" className="header-apply-link" onClick={closeMenu}>
            <button className="btn-pay-now">Pay Now</button>
          </Link>
        </div>

      </header>
    </>
  );
};

export default Header;
